import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form7.css";

const Form7 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    adventure: "",
    romantic: "",
    cultural: "",
    special: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.adventure.trim()) {
      err.adventure = "Please enter adventure activities";
    }

    if (!formData.romantic.trim()) {
      err.romantic = "Please enter romantic experiences";
    }

    if (!formData.cultural.trim()) {
      err.cultural = "Please enter cultural / heritage tours";
    }

    if (!formData.special.trim()) {
      err.special = "Please enter special requests";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

    const handleSubmit = (e) => {
      e.preventDefault();

      const isValid = validate();

      if (isValid) {
        navigate("/form8");
      }
    };


  return (
    <div className="activities-main">
      <div className="left-section">
        <h1>Activities & Experiences</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="activities-form">
          <label>Adventure activities</label>
          <input
            type="text"
            name="adventure"
            placeholder="List any activities like trekking, rafting, etc."
            value={formData.adventure}
            onChange={handleChange}
          />
          {errors.adventure && <p className="error">{errors.adventure}</p>}

          <label>Romantic experiences</label>
          <input
            type="text"
            name="romantic"
            placeholder="Enter any special romantic requests"
            value={formData.romantic}
            onChange={handleChange}
          />
          {errors.romantic && <p className="error">{errors.romantic}</p>}

          <label>Cultural / Heritage tours</label>
          <input
            type="text"
            name="cultural"
            placeholder="Specify your interest in tours"
            value={formData.cultural}
            onChange={handleChange}
          />
          {errors.cultural && <p className="error">{errors.cultural}</p>}

          <label>Special requests (birthday, anniversary, surprise)</label>
          <input
            type="text"
            name="special"
            placeholder="Any special requests?"
            value={formData.special}
            onChange={handleChange}
          />
          {errors.special && <p className="error">{errors.special}</p>}

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form7;
